<template>
  <el-drawer
    v-model="layerFlag"
    :close-on-click-modal="true"
    :destroy-on-close="true"
    :before-close="handleClose"
    direction="rtl"
    size="50%">
    <template #title>
      <div class="drawer-title">{{ title }}</div>
    </template>
    <template #default>
      <div v-show="!sk">
        <custom-form
          ref="refForm"
          :formData="formData"
          :formRules="formRules"
          @submitForm="submitForm"
        />
      </div>
      <div v-show="sk">
        <p>Secret：</p>
        {{ sk }}
        <div class="copy-wrap">
          <div class="copy">
            <svg-icon icon-class="copy" />
            <div class="copy" @click="copyFun(sk)">{{ $t('copy') }}</div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div>
        <el-button @click="handleClose">
          {{ $t('form.cancel') }}
        </el-button>
        <el-button v-if="sk === ''" type="primary" @click="submit">
          {{ $t('form.submit') }}
        </el-button>
        <el-button v-else type="primary" @click="handleClose">
          {{ $t('form.submit') }}
        </el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import { addAKSK, editAKSK } from '@/api/users/aksk'
import { useI18n } from 'vue-i18n'
import checkRules from '@/components/CustomCheck'
import { computed, ref, watch, reactive, toRefs } from 'vue'
import copy from '@/composables/copy'
export default {
  props: {
    addLayer: {
      type: Boolean,
      default: false
    },
    editType: {
      type: String,
      default: ''
    },
    row: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  emits: ['getList', 'update:addLayer'],
  setup(props, { emit }) {
    const { t } = useI18n()
    const { row, editType } = toRefs(props)
    const layerFlag = computed({
      get: () => props.addLayer,
      set: (value) => emit('update:addLayer', value)
    })
    const title = ref('')
    // 创建成功sk
    const sk = ref('')
    // 规则校验
    const { emptCheck } = checkRules(t)
    const formRules = {
      status: emptCheck,
      roles: emptCheck,
      description: emptCheck
    }
    const formData = reactive({
      status: {
        type: 'select',
        label: t('table.status'),
        value: null,
        prop: 'status',
        placeholder: '',
        options: [
          {
            id: 'enabled',
            name: t('table.enable')
          },
          {
            id: 'disabled',
            name: t('table.disable')
          }
        ]
      },
      roles: {
        type: 'select',
        label: t('user.role'),
        value: 'admin_docking',
        prop: 'roles',
        placeholder: '',
        options: [
          {
            id: 'admin_docking',
            name: t('user.platform_docking')
          },
          {
            id: 'admin_statistics',
            name: t('user.statistical_docking')
          }
        ]
      },
      description: {
        type: 'textarea',
        label: t('user.description'),
        value: '',
        prop: 'description',
        placeholder: ''
      }
    })
    const handleClose = () => {
      layerFlag.value = !layerFlag.value
    }
    // 提交
    const refForm = ref(null)
    const submit = () => {
      refForm.value.submit()
    }
    const submitForm = (form) => {
      form.validate(async valid => {
        if (valid) {
          const postVal = {}
          for (const i in formData) {
            postVal[i] = formData[i].value
          }
          if (editType.value === 'edit') {
            await editAKSK({ aksk_id: row.value.id, update_data: { ...postVal }})
            handleClose()
          } else {
            const res = await addAKSK(postVal)
            sk.value = res.data.sk
          }
          emit('getList')
        } else {
          console.log(false)
        }
      })
    }
    // 监听弹层显示与否
    watch(layerFlag, (nv, ov) => {
      if (nv) {
        if (editType.value === 'edit') {
          title.value = t('user.edit_aksk')
          for (const i in formData) {
            formData[i].value = row.value[i]
          }
        } else {
          title.value = t('user.add_aksk')
        }
      } else {
        sk.value = ''
        for (const i in formData) {
          formData[i].value = ''
        }
      }
    })
    return {
      formData,
      formRules,
      layerFlag,
      refForm,
      sk,
      title,
      handleClose,
      submit,
      submitForm
    }
  },
  methods: {
    copyFun(val) {
      copy(val)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
